export enum DownloadText {
    ALT_SUBTITLE = 'altSubtitle',
    ALT_TITLE = 'altTitle',
    SUBTITLE = 'subtitle',
    TITLE = 'title'
}

export enum DownloadState {
    PRISTINE = 'pristine',
    ACTIVE = 'active',
    ACTIVE_PLAY = 'activePlayable',
    INACTIVE = 'inactive',
    INACTIVE_PLAY = 'inactivePlayable',
    COMPLETED = 'completed',
    ERROR = 'error'
}

export default {
    states: DownloadState,
    textTypes: DownloadText
};
